<template>
  <router-view />
</template>
<script>
export default {
  name: "App",
  created: function () {
  },
  mounted() {
    if (this.$store.state.user) {
      if (!localStorage.getItem('token')) {
        localStorage.removeItem('token');
        this.$store.dispatch("setUser", null)
        setTimeout(function () {
          location.reload();
        }, 3000);
      }
      else{
        this.$router.push("/user/system-pages");
      }
    }
  },
  data: () => ({
    render: false,
    data: null,
  }),
};
</script>